// @flow
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import styles from './TermsOfServiceBanner.module.scss';
import Throbber from '@liveauctioneers/caterwaul-components/lib/Throbber/Throbber';

const tosLink = (
    <Link to="/termsandconditions" target="_blank" rel="noopener">
        <FormattedMessage id="terms_and_conditions" />
    </Link>
);
const privacyLink = (
    <Link to="/privacy" target="_blank" rel="noopener">
        <FormattedMessage id="privacy_policy" />
    </Link>
);
const cookieLink = (
    <Link to="/cookie-policy" target="_blank" rel="noopener">
        <FormattedMessage id="cookie_policy" />
    </Link>
);

type Props = {
    submitConsent: Function,
    submitted: boolean,
};

const TermsOfServiceBanner = (props: Props) => {
    const { submitted, submitConsent } = props;

    return (
        <div className={styles.banner}>
            <div className={styles['banner-inner']}>
                <div className={styles.text}>
                    <FormattedMessage id="terms_banner" values={{ cookieLink, privacyLink, tosLink }} />
                </div>
                <div>
                    <Button className={styles.submit} onClick={submitConsent} primary red>
                        {!submitted ? <FormattedMessage id="consent.agree" /> : <Throbber colorWhite />}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(TermsOfServiceBanner, isEqual);
